"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * getViewPortSize: get viewport size
 * @returns {number, number} width height
 */
const getViewPortSize = () => {
    let viewPortWidth;
    let viewPortHeight;
    let clientWidth = 1000;
    let clientHeight = 600;
    try {
        ({ clientWidth } = document.getElementsByTagName("body")[0]);
        ({ clientHeight } = document.getElementsByTagName("body")[0]);
    }
    catch (err) {
        // we have tryied get values
    }
    /* the more standards compliant browsers (mozilla/netscape/opera/IE7)
        use window.innerWidth and window.innerHeight */
    if (window.innerWidth) {
        viewPortWidth = window.innerWidth;
        viewPortHeight = window.innerHeight;
    }
    // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
    else if (document.documentElement &&
        document.documentElement.clientWidth &&
        document.documentElement.clientWidth !== 0) {
        viewPortWidth = document.documentElement.clientWidth;
        viewPortHeight = document.documentElement.clientHeight;
    }
    else {
        viewPortWidth = clientWidth;
        viewPortHeight = clientHeight;
    }
    return { viewPortWidth, viewPortHeight };
};
exports.default = getViewPortSize;
//# sourceMappingURL=index.js.map